
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class VImageUpload extends Vue {
  @Prop()
  public value!: string;

  @Prop()
  public rules!: [() => string | boolean];

  public file: File | string = "";
  public uploadFileName = "";
  public uploadFileSrc = "";

  public onFileChanged(file: File): Vue | void {
    if (!file) {
      return this.$emit("input", "");
    }
    if (!/^image/.test(file.type)) {
      return this.$emit("input", "");
    }

    this.uploadFileName = file.name;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.uploadFileSrc = reader.result as string;
      this.uploadFileName = file.name;
      this.$emit("input", reader.result);
    };
  }
}
